import { Router } from '@reach/router';
import React from 'react';
import Helmet from 'react-helmet';
import AccountLayout from '../../components/account-layout';
import { useTranslation } from '../../hooks/useTranslation';
import ROUTES from '../../routes';
import Chargepoint from '../../components/chargepoint';

export const ChargepointMain = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('IQPCD_HEADER')}</title>
      </Helmet>
      <AccountLayout>
        <Router basepath="/">
          <Chargepoint path={`${ROUTES.CHARGEPOINT}/*`} />
        </Router>
      </AccountLayout>
    </>
  );
};
export default ChargepointMain;
